import React, {useEffect} from 'react';
import t from 'babel-plugin-yate/macro';
import {Form, Field} from 'react-final-form';
import {useDispatch, useSelector} from 'react-redux';
import get from 'lodash-es/get';

import {isRequired} from '../../lib/validations';
import {getAddressType} from '../../store/request';
import {
  getCurrentStoredAddressLabel,
  getAddressDisabledStatus,
} from '../../config/cardDeliveryAddressHelpers';
import Condition from '../../components/Condition';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import {Text} from '../../components/uiElem';
import {Select} from '../../components/Form/Select';
import Address from '../../components/Address';

const ModalSaveCardAddress = props => {
  const {closeModal, onSubmit, id, uuid, addressData} = props;
  const dispatch = useDispatch();
  const addressType = useSelector(({request: {addressType}}) => addressType);

  useEffect(() => {
    if (!addressType) {
      dispatch(getAddressType(uuid));
    }
  }, [addressType, dispatch, uuid]);

  return (
    <Modal id={id} width="w-full max-w-md" allowClose={false}>
      <Form
        keepDirtyOnReinitialize={true}
        onSubmit={onSubmit}
        initialValues={addressData}
        render={({handleSubmit, values, form}) => {
          const cardDeliveryAddressId = get(
            values,
            'customer.card_data.address_type',
          );

          return (
            <form onSubmit={handleSubmit}>
              <div className="mb-2 p-6">
                <Text className="text-22 md:text-30 leading-tight mb-5 text-center text-grey-darkest font-medium">
                  {t`Adresa livrare card`}
                </Text>

                <Text ui="neptune">
                  <div className="text-center">
                    {t`Te rog sa introduci adresa de livrare a cardului prin curier, pentru a putea continua aplicatia de credit.`}
                  </div>
                </Text>

                <div className="mx-auto">
                  <div className="mb-2 hidden">
                    <div className="px-2 w-full">
                      <Field
                        name="customer.card_data.address_type"
                        label={t`Tip adresa`}
                        component={Select}
                        disabled={true}
                        validate={isRequired()}
                        /**
                         * by default 'Altele' is selected
                         **/
                        defaultValue="18408"
                        parse={value => {
                          const label = getCurrentStoredAddressLabel(
                            values,
                            value,
                          );

                          form.change(
                            'customer.card_data.card_address',
                            get(values, `customer.${label}`, {}),
                          );
                          return value;
                        }}>
                        <option value="" disabled>{t`Alege o adresa`}</option>
                        {addressType?.map(({name, code, display}) => {
                          return (
                            <option
                              key={`address-external-id-select-${code}`}
                              value={code}
                              hidden={!display}>
                              {name}
                            </option>
                          );
                        })}
                      </Field>
                    </div>
                  </div>

                  <div className="mt-12">
                    <Condition
                      when="customer.card_data.address_type"
                      is={addressType?.map(({code}) => code)}>
                      <Address
                        disabled={getAddressDisabledStatus(
                          cardDeliveryAddressId,
                        )}
                        defaultValueLabel={getCurrentStoredAddressLabel(
                          values,
                          cardDeliveryAddressId,
                        )}
                        form={form}
                        uuid={uuid}
                        postalCodeRequired={true}
                      />
                    </Condition>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap justify-between p-6 border-t">
                <Button
                  color="orange"
                  border={false}
                  title={t`Confirma`}
                  customProps={{type: 'submit'}}
                  buttonStyles="my-1 py-4 px-8 w-full sm:w-auto sm:min-w-64"
                />

                <Button
                  boxShadow={false}
                  border={true}
                  customProps={{type: 'button'}}
                  buttonStyles="my-1 py-4 px-8 w-full sm:w-auto sm:min-w-64 sm:ml-8"
                  onClick={closeModal}
                  title={t`Aleg alta oferta`}
                />
              </div>
            </form>
          );
        }}
      />
    </Modal>
  );
};

export default ModalSaveCardAddress;
